import React from 'react';

const ProductInquiryQr = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <span className="font-semibold text-gray-9 text-[20px] mb-2">직트럭 앱 다운로드</span>
      <span className="font-medium text-gray-8 text-[14px] leading-[18px] text-center">
        직트럭 어플 다운로드 후 차주에게
        <br />
        직접 구매문의를 할 수 있어요.
      </span>
      <div className="my-5 sm-only:w-[100px] sm680:w-[120px] sm680:h-[120px]">
        <img
          className="w-full h-full"
          src="https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/zigtruck_io.png"
          alt="qr_code"
        />
      </div>
      <span className="w-full font-medium text-gray-8 text-[16px] xxs:text-[15px] leading-[20px] text-center break-keep">
        휴대폰 카메라로 QR코드를 <br className="hidden sm280:block" />
        인식 후 <br className="sm280:hidden" />
        앱을 다운로드 받으세요.
      </span>
    </div>
  );
};

export default ProductInquiryQr;
